import React from "react"

import { RequestHandler } from "components/Shared/RequestHandler"
import { VSM_METRIC_NAME } from "components/Transactional/Benchmark/Benchmark.constant"
import { PenetrationSummaryFilters } from "components/Transactional/Performance/interfaces"
import { useGetPenetrationSummary } from "components/Transactional/Performance/hooks/useGetPenetrationSummary"
import SummaryTableSkeleton from "components/Transactional/Performance/components/SummaryTable/SummaryTableSkeleton/SummaryTableSkeleton"

import ValueShareModelContainer from "../ValueShareModelContainer"

import "./MetricsValueShareModel.styles.scss"

interface FiltersMetricVSM {
	filtersBenchmark: PenetrationSummaryFilters
}

const MetricsValueShareModel: React.FC<FiltersMetricVSM> = (props) => {
	const { filtersBenchmark } = props

	const DEFAULT_DATA = {
		commercialBenchmarkVsm: [],
	}

	const {
		reachData = DEFAULT_DATA,
		isLoading,
		isError,
		error,
		refetch,
	} = useGetPenetrationSummary(filtersBenchmark, VSM_METRIC_NAME)

	return (
		<div className="metrics-value-share-model">
			<RequestHandler
				hasData={Boolean(reachData?.commercialBenchmarkVsm)}
				error={error}
				isError={isError}
				isLoading={isLoading}
				retry={refetch}
				skeleton={<SummaryTableSkeleton iterate={3} />}
			>
				<ValueShareModelContainer vsmItems={reachData.commercialBenchmarkVsm} />
			</RequestHandler>
		</div>
	)
}

export default MetricsValueShareModel
